import {Component} from '@angular/core';
import { Auth } from 'aws-amplify';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';

@Component({
    selector: 'app-topbar',
    template: `
        <div class="layout-topbar">
            <div class="layout-topbar-wrapper">
                <div class="layout-topbar-left">
                    <div class="layout-topbar-logo" id="logolink" style="cursor: pointer; outline: none;" routerLink="/">
                        <img id="app-logo"
                             [src]="'assets/ck-capital-finance-logo.png'"
                             alt="CK Logo">
                    </div>
                </div>

                <div class="layout-topbar-right">
                    <a class="menu-button" href="#" (click)="appMain.onMenuButtonClick($event)">
                        <i class="pi pi-bars"></i>
                    </a>

                    <ul class="layout-topbar-actions">
                        <li #profile class="topbar-item user-profile">
                            <h6 class="pt-3 mr-3">{{userEmail}}</h6>
                        </li>
                        <li>
                            <i class="pi pi-sign-out" style="cursor:pointer" pTooltip="Sign Out" tooltipPosition="bottom" (click)="signOut()"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `
})
export class AppTopBarComponent {

    constructor(public appMain: AppMainComponent, public app: AppComponent) {
    }

    userEmail: string;

    async ngOnInit() {
        var userInfo = await Auth.currentUserInfo();
            
        if (userInfo) {
            this.userEmail = userInfo.attributes.email;
        }
    }

    async signOut() {
        await Auth.signOut();
        window.location.href="/dashboard";
    }

}
